import React from "react";
import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

const StockedMaterials = ({ materials }) => {
  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <VuiBox display="flex" flexDirection="column" height="100%" p={2} gap={2}>
        <VuiTypography variant="lg" color="white" fontWeight="bold">
          Stocked Materials
        </VuiTypography>

        {materials.length > 0 ? (
          <VuiBox
            display="grid"
            gridTemplateColumns="repeat(auto-fill, minmax(200px, 1fr))"
            gap={2}
          >
            {materials.map((material, index) => (
              <Card
                key={index}
                sx={{
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 2,
                  minHeight: 120,
                }}
              >
                <VuiTypography variant="h6" color="white">
                  {material.name}
                </VuiTypography>
                <VuiTypography variant="body2" color="white">
                  {Number(material.total).toFixed(2)}
                </VuiTypography>
              </Card>
            ))}
          </VuiBox>
        ) : (
          <VuiBox display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
            <VuiTypography variant="body1" color="white">
              No materials available
            </VuiTypography>
          </VuiBox>
        )}
      </VuiBox>
    </Card>
  );
};

export default StockedMaterials;